var __jsx = React.createElement;
import React from "react";
import { useRouter } from "next/router";
import { ELSLink } from "components/common/elsevier/Link/Link";
import { Events } from "services/adobeAnalytics/Events";
import Styles from "./Banner.module.scss";
function AiBanner() {
  var router = useRouter();
  var redirectToAISearchPage = function redirectToAISearchPage() {
    // Cut natural language search event
    Events.semanticSearch.tryNLS();
    router.replace("/search/ai");
  };
  return /*#__PURE__*/React.createElement("div", {
    className: Styles.ai__banner,
    "data-cy": "ai-banner-text"
  }, /*#__PURE__*/React.createElement("img", {
    className: Styles.ai__banner__icon,
    alt: "",
    src: "".concat(process.env.customBasePath, "/static/images/GizmoIcons/ev-ai-gizmo-stars.svg")
  }), /*#__PURE__*/React.createElement("p", {
    className: Styles.ai__banner__title
  }, "Take a deeper dive into unfamiliar topics with Engineering Village AI."), /*#__PURE__*/React.createElement(ELSLink, {
    "data-cy": "ai-try-button",
    "data-aa-region": "aa-link-to-ai",
    "data-aa-name": "Let's go!",
    onClick: redirectToAISearchPage,
    tabIndex: 0,
    className: "es-link__white--16-font--text-underline ".concat(Styles.ai__banner__link)
  }, "Try it now"));
}
export default AiBanner;